'use client';

import { createContext, useContext, useRef, useState } from 'react';

export type UserUIProps =
  | {
      isCartOpen: boolean;
      setIsCartOpen: React.Dispatch<React.SetStateAction<boolean>>;
      hideHeaderRef: React.RefObject<HTMLElement | null>;
      isAddressSelectOpen: boolean;
      setIsAddressSelectOpen: React.Dispatch<React.SetStateAction<boolean>>;
    }
  | undefined;

export const UIStateContext = createContext<UserUIProps>(undefined);

export const UIStateContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isAddressSelectOpen, setIsAddressSelectOpen] = useState(false);
  const hideHeaderRef = useRef<HTMLElement>(null);

  const value = {
    isCartOpen,
    setIsCartOpen,
    hideHeaderRef,
    isAddressSelectOpen,
    setIsAddressSelectOpen,
  };

  return <UIStateContext.Provider value={value}>{children}</UIStateContext.Provider>;
};

export function useUIStateContext() {
  const ctx = useContext(UIStateContext);
  if (!ctx) {
    throw new Error('useUIStateContext must be used within a UIStateProvider');
  }
  return ctx;
}
